import { render, staticRenderFns } from "./WxQualityInspectPage.vue?vue&type=template&id=30fac84a&scoped=true&"
import script from "./WxQualityInspectPage.vue?vue&type=script&lang=js&"
export * from "./WxQualityInspectPage.vue?vue&type=script&lang=js&"
import style0 from "./WxQualityInspectPage.vue?vue&type=style&index=0&id=30fac84a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30fac84a",
  null
  
)

export default component.exports